module.exports = __webpack_public_path__ + "static/hero-b390caae9c7314fdf9ee2bd99a74b7c1.png";